import React from "react";
import { StepperWrapper } from "../stepper/StepperWrapper";
import { StepperContent } from "../stepper/StepperContent";
import { Box, Tooltip, Typography, Button } from "@material-ui/core";

export class SingleRegistryHeader extends React.Component {
  render() {
    const { currentStep, headerTitle } = this.props;

    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          marginBottom: "24px",
          width: "100%",
          textAlign: "left",
        }}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            minWidth: 40,
            borderRadius: "10px",
            bgcolor: "#F3F6FC",
            color: "#1E293B",
            border: "2px solid #1E293B",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 0,
            "&:hover": {
              bgcolor: "#E8EEF9",
              borderColor: "#111827",
            },
            "&:active": {
              bgcolor: "#DFE7F5",
              transform: "translateY(1px)",
            },
            "&.Mui-focusVisible, &:focus-visible": {
              outline: "none",
              boxShadow: "0 0 0 3px rgba(59,130,246,0.35)",
            },
            "& svg": {
              width: 22,
              height: 22,
              stroke: "currentColor",
              strokeWidth: 1.5,
            },
            "& svg path": {
              stroke: "currentColor",
            },
            textTransform: "none",
          }}
          component={Button}
          onClick={currentStep?.actions?.return?.onClick}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M9.57 5.92993L3.5 11.9999L9.57 18.0699"
              stroke="#1E293B"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20.5 12H3.67001"
              stroke="#1E293B"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Box>

        <Typography
          variant="h1"
          sx={{
            margin: 0,
            fontSize: "32px",
            lineHeight: 1.2,
            fontWeight: 700,
            color: "#0F172A",
          }}
        >
          {headerTitle}
        </Typography>
      </Box>
    );
  }
}
export class SingleRegistryView extends React.Component {
  state = {
    currentStepId: this.props.steppers[0]?.id ?? null,
  };

  handlerOnClickStep(step) {
    if (this.props.stepClickDisabled) return;
    this.setState({ currentStepId: step.id });
  }

  findStepOrReturnFirst(stepId) {
    return (
      this.props.steppers?.find(({ id }) => stepId === id) ??
      this.props.steppers[0]
    );
  }

  async handleNextButtonClick() {
    const onNext = this.findStepOrReturnFirst(this.state.currentStepId)?.actions
      ?.next?.onClick;

    if (typeof onNext === "function") {
      const allowed = await onNext();
      if (!allowed) return;
    }
    const next = this.findStepOrReturnFirst(this.state.currentStepId + 1);
    this.setState({ currentStepId: next.id });
  }

  handlePrevButtonClick() {
    const current = this.findStepOrReturnFirst(this.state.currentStepId);
    const customOnClick = current?.actions?.prev?.onClick;
    const prev = this.findStepOrReturnFirst(this.state.currentStepId - 1);

    const navigateBack = () => this.setState({ currentStepId: prev.id });

    if (typeof customOnClick === "function") {
      customOnClick(navigateBack);
      return;
    }

    navigateBack();
  }

  render() {
    const currentStep = this.findStepOrReturnFirst(this.state.currentStepId);
    const isNextDisabled = currentStep?.actions?.next?.isDisabled?.() ?? false;
    const nextButtonTooltip = currentStep?.actions?.next?.disabledTooltip;
    const isLastStep =
      this.props.steppers &&
      this.props.steppers.length > 0 &&
      this.props.steppers[this.props.steppers.length - 1].id ===
      currentStep?.id;

    const shouldShowPrev =
      currentStep?.actions?.prev &&
      currentStep?.actions?.prev?.isShow !== false;

    return (
      <Box>
        <Box
          sx={{
            padding: "20px 8px 8px",
            "& .page-title": {
              display: "flex",
              alignItems: "center",
              marginBottom: "0.5rem",
            },
            "& .page-title .btn-icon": {
              margin: "0 1rem 0 0",
              padding: "0.5rem",
              border: "solid 2px #000",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "5px",
            },
          }}
        >

          {this.props?.hasHeader && (
            <SingleRegistryHeader
              headerTitle={this.props.headerTitle}
              currentStep={currentStep}
            />
          )}

          <StepperWrapper
            steppers={this.props?.steppers ?? []}
            currentStep={currentStep}
            onClickStep={this.handlerOnClickStep.bind(this)}
            hideStepper={currentStep?.hideStepper}
          >
            <StepperContent>{currentStep?.component}</StepperContent>
            <Box
              sx={{
                marginTop: "1rem",
                padding: "1rem",
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              {shouldShowPrev && !isLastStep ? (
                <Button
                  className="v3-button"
                  onClick={this.handlePrevButtonClick.bind(this)}
                  disabled={
                    typeof currentStep?.actions?.prev?.isDisabled === "function"
                      ? currentStep.actions.prev.isDisabled()
                      : !this.props.modulePath
                  }
                >
                  {currentStep?.actions?.prev?.text ?? "Prev"}
                </Button>
              ) : (
                <div />
              )}
              <Box>
                <Box sx={{ display: "flex" }}>
                  {currentStep?.actions?.prev?.isShow && (
                    <Button
                      style={{
                        marginRight: "16px",
                      }}
                      className="v3-button"
                      onClick={currentStep?.actions?.prev?.onClick}
                    >
                      {currentStep?.actions?.prev?.text ?? ""}
                    </Button>
                  )}

                  {currentStep?.actions?.next && (
                    <Tooltip
                      title={nextButtonTooltip || ""}
                      placement="top"
                      arrow
                      slotprops={{
                        tooltip: {
                          sx: {
                            bgcolor: "#0F172A",
                            color: "#FFFFFF",
                            px: 2.5,
                            py: 2,
                            borderRadius: 3,
                            maxWidth: 380,
                            fontSize: 14,
                            lineHeight: 1.4,
                            boxShadow: "none",
                            position: "relative",
                            "&::after": {
                              content: '""',
                              position: "absolute",
                              right: -8,
                              top: "50%",
                              transform: "translateY(-50%) rotate(45deg)",
                              width: 14,
                              height: 14,
                              backgroundColor: "#0F172A",
                              borderTopRightRadius: 10,
                            },
                            '&[data-popper-placement*="top"]::after': {
                              right: -8,
                            },
                          },
                        },
                        arrow: {
                          sx: {
                            color: "transparent",
                            "&::before": {
                              backgroundColor: "transparent",
                              border: "none",
                            },
                          },
                        },
                      }}
                    >
                      <span>
                        <Button
                          className="v3-button black"
                          onClick={this.handleNextButtonClick.bind(this)}
                          disabled={isNextDisabled}
                        >
                          {currentStep?.actions?.next?.text ?? "Next"}
                        </Button>
                      </span>
                    </Tooltip>
                  )}
                </Box>
              </Box>
            </Box>
          </StepperWrapper>
        </Box>
      </Box>
    );
  }
}
